<template>
  <!--show this button only on non-super admin-->
  <BaseTableItemAction
    v-can:[deletePermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-delete"
    actionName="حذف"
    v-if="item.id!=1" 
    @click="openDeleteDialog()"
  >
    <DeleteAdminDialog
      :showCondition="showDeleteDialog"
      :item="item"
      :goBackWhenItsFinished="goBackWhenItsFinished"
      @closed="closeDeleteDialog"
    />
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_ADMINS_PERMISSION } from "@/core/statics/Permissions";
import DeleteAdminDialog from "../dialogs/DeleteAdminDialog.vue";

export default {
  components: { DeleteAdminDialog },
  props: {
    item: Object,
    goBackWhenItsFinished: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletePermission: WRITE_ADMINS_PERMISSION,
      showDeleteDialog: false,
    };
  },
  methods: {
    openDeleteDialog() {
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
};
</script>
